import React from 'react';

import { C, HL, Lbl, Div } from './svgPrimitives';



export const coreVisuals = {

  stock_ownership: (

    <svg viewBox="0 0 200 110" className="w-full">

      <rect x="70" y="18" width="60" height="60" rx="4" fill="#e0ecff" stroke="#6366F1" strokeWidth="1.5" />

      <rect x="78" y="26" width="12" height="12" fill="#bfdbfe" />

      <rect x="94" y="26" width="12" height="12" fill="#bfdbfe" />

      <rect x="110" y="26" width="12" height="12" fill="#bfdbfe" />

      <rect x="78" y="42" width="12" height="12" fill="#bfdbfe" />

      <rect x="94" y="42" width="12" height="12" fill="#bfdbfe" />

      <rect x="110" y="42" width="12" height="12" fill="#bfdbfe" />

      <rect x="94" y="58" width="12" height="20" fill="#93c5fd" />



      <circle cx="38" cy="52" r="10" fill="#16C784" opacity="0.2" stroke="#16C784" strokeWidth="1.5" />

      <text x="38" y="55" fill="#16a34a" fontSize="7" textAnchor="middle" fontFamily="sans-serif">Share</text>



      <line x1="48" y1="52" x2="70" y2="48" stroke="#64748b" strokeWidth="1.5" strokeDasharray="3,2" />



      <text x="100" y="94" fill="#64748b" fontSize="8" textAnchor="middle" fontFamily="sans-serif">

        One share = tiny ownership

      </text>

    </svg>

  ),



  single_candle: (

    <svg viewBox="0 0 200 110" className="w-full">

      <C x={85} o={78} c={28} h={12} l={95} w={30} />

      <HL y={12} x1={60} x2={85} color="#94a3b8" dash />

      <Lbl x={58} y={15} text="H" anchor="end" />

      <HL y={28} x1={60} x2={85} color="#16C784" dash />

      <Lbl x={58} y={31} text="C" anchor="end" color="#16C784" />

      <HL y={78} x1={60} x2={85} color="#16C784" dash />

      <Lbl x={58} y={81} text="O" anchor="end" color="#16C784" />

      <HL y={95} x1={60} x2={85} color="#94a3b8" dash />

      <Lbl x={58} y={98} text="L" anchor="end" />

      <text x="125" y="38" fill="#16C784" fontSize="9" fontFamily="sans-serif">^ Buyers pushed</text>

      <text x="125" y="78" fill="#ef4444" fontSize="9" fontFamily="sans-serif">v Sellers pushed</text>

    </svg>

  ),



  body_wick: (

    <svg viewBox="0 0 200 110" className="w-full">

      <Div />

      <C x={28} o={75} c={22} h={15} l={82} w={32} />

      <Lbl x={44} y={105} text="Strength" color="#16C784" />

      <C x={128} o={58} c={52} h={8} l={100} w={32} />

      <Lbl x={144} y={105} text="Rejection" color="#ef4444" />

    </svg>

  ),



  size_matters: (

    <svg viewBox="0 0 200 110" className="w-full">

      <C x={10} o={55} c={50} h={47} l={58} w={13} />

      <C x={26} o={52} c={57} h={50} l={60} w={13} />

      <C x={42} o={55} c={50} h={47} l={58} w={13} />

      <text x="65" y="57" fill="#94a3b8" fontSize="16">-></text>

      <C x={88} o={82} c={15} h={10} l={86} w={32} />

      <Lbl x={36} y={105} text="Indecision" color="#94a3b8" />

      <Lbl x={104} y={105} text="Momentum" color="#16C784" />

    </svg>

  ),



  speed: (

    <svg viewBox="0 0 200 110" className="w-full">

      <Div />

      <C x={5}  o={85} c={78} h={76} l={87} w={10} />

      <C x={18} o={78} c={85} h={82} l={88} w={10} />

      <C x={31} o={82} c={76} h={74} l={84} w={10} />

      <C x={44} o={77} c={70} h={68} l={79} w={10} />

      <Lbl x={35} y={105} text="Slow / Weak" color="#94a3b8" />

      <C x={110} o={88} c={72} h={69} l={90} w={10} />

      <C x={123} o={72} c={52} h={49} l={74} w={10} />

      <C x={136} o={52} c={30} h={27} l={54} w={10} />

      <C x={149} o={30} c={12} h={9}  l={32} w={10} />

      <Lbl x={145} y={105} text="Fast / Strong" color="#16C784" />

    </svg>

  ),



  trend_sideways: (

    <svg viewBox="0 0 200 110" className="w-full">

      <Div />

      <C x={5}  o={85} c={73} h={70} l={87} w={10} />

      <C x={18} o={75} c={85} h={82} l={88} w={10} />

      <C x={31} o={68} c={56} h={53} l={70} w={10} />

      <C x={44} o={58} c={68} h={65} l={71} w={10} />

      <C x={57} o={52} c={40} h={37} l={54} w={10} />

      <Lbl x={38} y={105} text="Trend" color="#16C784" />

      <C x={108} o={55} c={48} h={44} l={59} w={10} />

      <C x={121} o={50} c={57} h={54} l={62} w={10} />

      <C x={134} o={54} c={48} h={44} l={58} w={10} />

      <C x={147} o={51} c={58} h={55} l={63} w={10} />

      <C x={160} o={55} c={49} h={45} l={60} w={10} />

      <Lbl x={142} y={105} text="Sideways / Noise" color="#94a3b8" />

    </svg>

  ),



  hh_hl: (

    <svg viewBox="0 0 200 110" className="w-full">

      <polyline points="15,85 45,52 75,65 115,35 148,48 180,18"

        fill="none" stroke="#16C784" strokeWidth="2" />

      {[{cx:45,cy:52},{cx:115,cy:35},{cx:180,cy:18}].map((p,i)=>(

        <g key={i}>

          <circle cx={p.cx} cy={p.cy} r="3.5" fill="#16C784" />

          <text x={p.cx} y={p.cy-7} fill="#16C784" fontSize="8" textAnchor="middle">HH</text>

        </g>

      ))}

      {[{cx:15,cy:85},{cx:75,cy:65},{cx:148,cy:48}].map((p,i)=>(

        <g key={i}>

          <circle cx={p.cx} cy={p.cy} r="3.5" fill="#6366F1" />

          <text x={p.cx} y={p.cy+12} fill="#6366F1" fontSize="8" textAnchor="middle">HL</text>

        </g>

      ))}

    </svg>

  ),



  breakout: (

    <svg viewBox="0 0 200 110" className="w-full">

      <HL y={38} color="#ef4444" dash />

      <Lbl x={190} y={35} text="Resistance" color="#ef4444" anchor="end" />

      <C x={10} o={65} c={58} h={55} l={68} w={11} />

      <C x={24} o={60} c={67} h={64} l={72} w={11} />

      <C x={38} o={65} c={59} h={56} l={68} w={11} />

      <C x={52} o={62} c={68} h={65} l={72} w={11} />

      <C x={66} o={66} c={60} h={57} l={69} w={11} />

      <C x={84} o={65} c={15} h={10} l={68} w={22} />

      <text x="135" y="25" fill="#16C784" fontSize="18">^</text>

      <Lbl x={155} y={20} text="Breakout" color="#16C784" />

    </svg>

  ),



  rejection: (

    <svg viewBox="0 0 200 110" className="w-full">

      <HL y={18} color="#ef4444" dash />

      <Lbl x={190} y={15} text="Resistance" color="#ef4444" anchor="end" />

      <C x={30} o={45} c={40} h={28} l={48} w={20} />

      <C x={60} o={42} c={38} h={25} l={52} w={20} />

      <C x={90} o={40} c={68} h={12} l={72} w={28} />

      <text x="135" y="25" fill="#ef4444" fontSize="12">Wick</text>

      <text x="135" y="40" fill="#ef4444" fontSize="12">Rejection</text>

    </svg>

  ),



  sr_bounces: (

    <svg viewBox="0 0 200 110" className="w-full">

      <HL y={30} color="#16C784" dash />

      <Lbl x={5} y={25} text="Support" color="#16C784" />

      <C x={20} o={50} c={35} h={32} l={55} w={12} />

      <C x={40} o={35} c={50} h={48} l={58} w={12} />

      <C x={60} o={50} c={38} h={35} l={56} w={12} />

      <C x={80} o={38} c={48} h={45} l={57} w={12} />

      <C x={100} o={48} c={40} h={37} l={54} w={12} />

      <text x="150" y="80" fill="#16C784" fontSize="10">Bounces</text>

    </svg>

  ),



  volume_confirm: (

    <svg viewBox="0 0 200 110" className="w-full">

      <Div />

      <rect x={15} y={70} width={12} height={20} fill="#94a3b8" />

      <rect x={35} y={65} width={12} height={25} fill="#94a3b8" />

      <rect x={55} y={60} width={12} height={30} fill="#94a3b8" />

      <rect x={75} y={30} width={20} height={60} fill="#16C784" opacity="0.8" />

      <text x="100" y="25" fill="#16C784" fontSize="14">^</text>

      <Lbl x={60} y={105} text="Volume Spike + Breakout" color="#16C784" />

    </svg>

  ),



  strength_weakness: (

    <svg viewBox="0 0 200 110" className="w-full">

      <Div />

      <C x={15} o={82} c={70} h={68} l={84} w={14} />

      <C x={32} o={70} c={55} h={52} l={72} w={14} />

      <C x={49} o={55} c={40} h={38} l={57} w={14} />

      <Lbl x={35} y={105} text="Weak" color="#94a3b8" />

      <C x={100} o={80} c={50} h={48} l={82} w={14} />

      <C x={117} o={50} c={30} h={28} l={52} w={14} />

      <C x={134} o={30} c={15} h={13} l={32} w={14} />

      <C x={151} o={15} c={8}  h={6}  l={18} w={14} />

      <Lbl x={140} y={105} text="Strong" color="#16C784" />

    </svg>

  ),



  pullback: (

    <svg viewBox="0 0 200 110" className="w-full">

      <polyline points="20,70 50,40 80,50 120,20" fill="none" stroke="#16C784" strokeWidth="2" />

      <circle cx={80} cy={50} r="4" fill="#f59e0b" />

      <Lbl x={85} y={70} text="Pullback (Entry)" color="#f59e0b" />

    </svg>

  ),



  reversal: (

    <svg viewBox="0 0 200 110" className="w-full">

      <polyline points="20,30 60,60 100,50 140,75 180,85" fill="none" stroke="#ef4444" strokeWidth="2" />

      <circle cx={100} cy={50} r="5" fill="#f59e0b" />

      <Lbl x={80} y={35} text="Reversal" color="#f59e0b" />

    </svg>

  ),



  do_nothing: (

    <svg viewBox="0 0 200 110" className="w-full">

      <C x={10} o={45} c={55} h={50} l={60} w={14} />

      <C x={30} o={55} c={40} h={38} l={62} w={14} />

      <C x={50} o={40} c={50} h={48} l={58} w={14} />

      <C x={70} o={50} c={42} h={40} l={60} w={14} />

      <C x={90} o={42} c={52} h={50} l={60} w={14} />

      <text x="120" y="40" fill="#94a3b8" fontSize="14">X</text>

      <Lbl x={100} y={100} text="No Clear Direction" color="#94a3b8" />

    </svg>

  ),



  three_checks: (

    <svg viewBox="0 0 200 110" className="w-full">

      <circle cx={40} cy={40} r={25} fill="none" stroke="#16C784" strokeWidth="2" />

      <text x={40} y={45} fill="#16C784" fontSize="20" textAnchor="middle">OK</text>

      <Lbl x={40} y={75} text="Trend" color="#16C784" />

      <circle cx={100} cy={40} r={25} fill="none" stroke="#16C784" strokeWidth="2" />

      <text x={100} y={45} fill="#16C784" fontSize="20" textAnchor="middle">OK</text>

      <Lbl x={100} y={75} text="Event" color="#16C784" />

      <circle cx={160} cy={40} r={25} fill="none" stroke="#16C784" strokeWidth="2" />

      <text x={160} y={45} fill="#16C784" fontSize="20" textAnchor="middle">OK</text>

      <Lbl x={160} y={75} text="Confirmation" color="#16C784" />

    </svg>

  ),



  no_confirm: (

    <svg viewBox="0 0 200 110" className="w-full">

      <HL y={35} color="#ef4444" dash />

      <C x={80} o={45} c={25} h={20} l={50} w={24} />

      <text x="125" y="35" fill="#ef4444" fontSize="12">Close below</text>

      <text x="125" y="50" fill="#ef4444" fontSize="12">resistance</text>

    </svg>

  ),



  waiting: (

    <svg viewBox="0 0 200 110" className="w-full">

      <circle cx={100} cy={55} r="40" fill="none" stroke="#6366F1" strokeWidth="3" />

      <text x={100} y={65} fill="#6366F1" fontSize="20" fontWeight="bold" textAnchor="middle">| |</text>

      <Lbl x={100} y={105} text="Waiting is a Decision" color="#6366F1" />

    </svg>

  ),



  risk_first: (

    <svg viewBox="0 0 200 110" className="w-full">

      <text x={40} y={35} fill="#ef4444" fontSize="12">RISK</text>

      <text x={40} y={50} fill="#ef4444" fontSize="24" textAnchor="middle">v</text>

      <text x={40} y={75} fill="#ef4444" fontSize="16" textAnchor="middle">₹100</text>

      <text x={150} y={35} fill="#16C784" fontSize="12">REWARD</text>

      <text x={150} y={50} fill="#16C784" fontSize="24" textAnchor="middle">^</text>

      <text x={150} y={75} fill="#16C784" fontSize="16" textAnchor="middle">₹300</text>

    </svg>

  ),



  early_entry: (

    <svg viewBox="0 0 200 110" className="w-full">

      <HL y={40} color="#ef4444" dash />

      <text x="20" y="35" fill="#ef4444" fontSize="10">resistance</text>

      <C x={60} o={50} c={35} h={32} l={52} w={18} />

      <circle cx={75} cy={45} r="5" fill="#f59e0b" />

      <text x="95" y="50" fill="#f59e0b" fontSize="10">Early entry</text>

      <text x="95" y="65" fill="#f59e0b" fontSize="10">(no confirmation)</text>

    </svg>

  ),



  chasing: (

    <svg viewBox="0 0 200 110" className="w-full">

      <polyline points="20,70 60,40 100,30 150,20" fill="none" stroke="#16C784" strokeWidth="2" />

      <circle cx={20} cy={70} r="4" fill="#16C784" />

      <circle cx={150} cy={20} r="6" fill="#f59e0b" />

      <Lbl x={140} y={40} text="Late chase" color="#f59e0b" />

    </svg>

  ),



  no_context: (

    <svg viewBox="0 0 200 110" className="w-full">

      <text x={100} y={30} fill="#94a3b8" fontSize="12" textAnchor="middle">5-min: Bullish</text>

      <circle cx={100} cy={50} r="8" fill="#16C784" opacity="0.3" />

      <polyline points="20,80 50,85 80,70 110,75 140,60 170,65" fill="none" stroke="#ef4444" strokeWidth="2" />

      <text x={100} y={105} fill="#ef4444" fontSize="11" textAnchor="middle">But Daily: Downtrend</text>

    </svg>

  ),



  overtrading: (

    <svg viewBox="0 0 200 110" className="w-full">

      <text x={50} y={40} fill="#ef4444" fontSize="16" fontWeight="bold">5 trades</text>

      <text x={50} y={60} fill="#ef4444" fontSize="12">all small loss</text>

      <text x={150} y={50} fill="#94a3b8" fontSize="14">X</text>

    </svg>

  ),



  decision_outcome: (

    <svg viewBox="0 0 200 110" className="w-full">

      <circle cx={50} cy={55} r="30" fill="none" stroke="#16C784" strokeWidth="2" />

      <text x={50} y={65} fill="#16C784" fontSize="16" textAnchor="middle">OK</text>

      <Lbl x={50} y={105} text="Good Process" color="#16C784" />

      <circle cx={150} cy={55} r="30" fill="none" stroke="#f59e0b" strokeWidth="2" strokeDasharray="5,3" />

      <text x={150} y={65} fill="#f59e0b" fontSize="14" textAnchor="middle">?</text>

      <Lbl x={150} y={105} text="Bad Outcome" color="#f59e0b" />

    </svg>

  ),



  traps_real: (

    <svg viewBox="0 0 200 110" className="w-full">

      <HL y={40} color="#ef4444" dash />

      <C x={60} o={42} c={25} h={20} l={50} w={18} />

      <text x="100" y="35" fill="#ef4444" fontSize="10">Trap</text>

      <polyline points="140,40 160,35 175,20" fill="none" stroke="#16C784" strokeWidth="2" />

      <text x="150" y="55" fill="#16C784" fontSize="10">Real move</text>

    </svg>

  ),



  equity_curve: (

    <svg viewBox="0 0 200 110" className="w-full">

      <polyline points="20,80 50,75 80,72 110,60 140,45 170,30" fill="none" stroke="#16C784" strokeWidth="2" />

      <Lbl x={100} y={105} text="Consistent Process = Rising Curve" color="#16C784" />

    </svg>

  ),



  forced_patient: (

    <svg viewBox="0 0 200 110" className="w-full">

      <text x={50} y={40} fill="#ef4444" fontSize="13">Forced</text>

      <text x={50} y={60} fill="#ef4444" fontSize="11">= Losing</text>

      <text x={150} y={40} fill="#16C784" fontSize="13">Patient</text>

      <text x={150} y={60} fill="#16C784" fontSize="11">= Winning</text>

    </svg>

  ),



  pat_double_bottom: (

    <svg viewBox="0 0 200 110" className="w-full">

      <HL y={70} color="#94a3b8" dash />

      <polyline points="20,70 50,50 80,70 110,40 140,70 170,30" fill="none" stroke="#16C784" strokeWidth="2" />

      <Lbl x={100} y={105} text="W-Shape: Double Bottom" color="#16C784" />

    </svg>

  ),



  pat_double_top: (

    <svg viewBox="0 0 200 110" className="w-full">

      <HL y={40} color="#ef4444" dash />

      <polyline points="20,40 50,60 80,40 110,70 140,40 170,80" fill="none" stroke="#ef4444" strokeWidth="2" />

      <Lbl x={100} y={105} text="M-Shape: Double Top" color="#ef4444" />

    </svg>

  ),



  pat_triple_bottom: (

    <svg viewBox="0 0 200 110" className="w-full">

      <HL y={75} color="#16C784" dash />

      <polyline points="15,75 35,55 55,75 75,50 95,75 115,45 135,75 155,35 175,50" fill="none" stroke="#16C784" strokeWidth="2" />

      <Lbl x={100} y={105} text="Triple Bottom: Strongest" color="#16C784" />

    </svg>

  ),



  pat_triple_top: (

    <svg viewBox="0 0 200 110" className="w-full">

      <HL y={35} color="#ef4444" dash />

      <polyline points="15,35 35,55 55,35 75,60 95,35 115,65 135,35 155,70 175,40" fill="none" stroke="#ef4444" strokeWidth="2" />

      <Lbl x={100} y={105} text="Triple Top: Strong Reversal" color="#ef4444" />

    </svg>

  ),



  pat_head_shoulders: (

    <svg viewBox="0 0 200 110" className="w-full">

      <HL y={65} color="#ef4444" dash />

      <polyline points="30,65 55,50 80,65 105,35 130,65 155,50 175,70" fill="none" stroke="#ef4444" strokeWidth="2" />

      <Lbl x={100} y={105} text="Head & Shoulders: H > S" color="#ef4444" />

    </svg>

  ),



  pat_inv_head_shoulders: (

    <svg viewBox="0 0 200 110" className="w-full">

      <HL y={45} color="#16C784" dash />

      <polyline points="30,45 55,60 80,45 105,75 130,45 155,60 175,30" fill="none" stroke="#16C784" strokeWidth="2" />

      <Lbl x={100} y={105} text="Inv. Head & Shoulders" color="#16C784" />

    </svg>

  ),



  pat_asc_triangle: (

    <svg viewBox="0 0 200 110" className="w-full">

      <HL y={50} color="#94a3b8" dash />

      <polyline points="30,50 60,50 90,65 120,60 150,70 180,65" fill="none" stroke="#16C784" strokeWidth="2" />

      <Lbl x={100} y={105} text="Ascending Triangle" color="#16C784" />

    </svg>

  ),



  pat_desc_triangle: (

    <svg viewBox="0 0 200 110" className="w-full">

      <HL y={70} color="#94a3b8" dash />

      <polyline points="30,70 60,70 90,55 120,60 150,50 180,45" fill="none" stroke="#ef4444" strokeWidth="2" />

      <Lbl x={100} y={105} text="Descending Triangle" color="#ef4444" />

    </svg>

  ),



  pat_bull_flag: (

    <svg viewBox="0 0 200 110" className="w-full">

      <polyline points="40,75 40,40" fill="none" stroke="#16C784" strokeWidth="3" />

      <polyline points="50,50 70,45 75,55 65,58" fill="none" stroke="#16C784" strokeWidth="2" />

      <Lbl x={60} y={105} text="Flag" color="#16C784" />

      <Lbl x={35} y={80} text="Pole" color="#16C784" />

    </svg>

  ),



  pat_support_bounce: (

    <svg viewBox="0 0 200 110" className="w-full">

      <HL y={75} color="#16C784" dash />

      <polyline points="30,50 70,75 110,45 150,75 190,40" fill="none" stroke="#16C784" strokeWidth="2" />

      <Lbl x={100} y={105} text="Support Bounce" color="#16C784" />

    </svg>

  ),



  pat_resistance_rejection: (

    <svg viewBox="0 0 200 110" className="w-full">

      <HL y={40} color="#ef4444" dash />

      <polyline points="30,70 70,40 100,60 140,40 180,70" fill="none" stroke="#ef4444" strokeWidth="2" />

      <Lbl x={100} y={105} text="Resistance Rejection" color="#ef4444" />

    </svg>

  ),



  // Scanner visuals (27 - Level 7)

  RSI_OVERSOLD: (

    <svg viewBox="0 0 200 80" className="w-full">

      <HL y={20} x1={5} x2={195} color="#ef4444" dash />

      <Lbl x={190} y={18} text="30" color="#ef4444" anchor="end" size={7} />

      <HL y={55} x1={5} x2={195} color="#94a3b8" dash />

      <Lbl x={190} y={53} text="50" color="#94a3b8" anchor="end" size={7} />

      <polyline points="5,45 35,50 65,48 95,40 125,22 155,14 185,18" fill="none" stroke="#ef4444" strokeWidth="2" />

      <circle cx="155" cy="14" r="4" fill="#ef4444" />

      <Lbl x={100} y={75} text="RSI dips below 30  -  oversold zone" color="#ef4444" />

    </svg>

  ),



  RSI_OVERBOUGHT: (

    <svg viewBox="0 0 200 80" className="w-full">

      <HL y={20} x1={5} x2={195} color="#ef4444" dash />

      <Lbl x={190} y={18} text="70" color="#ef4444" anchor="end" size={7} />

      <HL y={50} x1={5} x2={195} color="#94a3b8" dash />

      <Lbl x={190} y={48} text="50" color="#94a3b8" anchor="end" size={7} />

      <polyline points="5,48 35,45 65,42 95,35 125,22 155,14 185,16" fill="none" stroke="#ef4444" strokeWidth="2" />

      <circle cx="155" cy="14" r="4" fill="#ef4444" />

      <Lbl x={100} y={75} text="RSI above 70  -  overbought zone" color="#ef4444" />

    </svg>

  ),



  RSI_CROSS_ABOVE_60: (

    <svg viewBox="0 0 200 80" className="w-full">

      <HL y={28} x1={5} x2={195} color="#16C784" dash />

      <Lbl x={190} y={26} text="60" color="#16C784" anchor="end" size={7} />

      <HL y={52} x1={5} x2={195} color="#94a3b8" dash />

      <Lbl x={190} y={50} text="50" color="#94a3b8" anchor="end" size={7} />

      <polyline points="5,55 45,52 80,48 115,38 145,28 175,18" fill="none" stroke="#16C784" strokeWidth="2" />

      <circle cx="145" cy="28" r="4" fill="#16C784" />

      <Lbl x={100} y={75} text="RSI crosses above 60  -  momentum builds" color="#16C784" />

    </svg>

  ),



  RSI_CROSS_BELOW_40: (

    <svg viewBox="0 0 200 80" className="w-full">

      <HL y={48} x1={5} x2={195} color="#ef4444" dash />

      <Lbl x={190} y={46} text="40" color="#ef4444" anchor="end" size={7} />

      <HL y={32} x1={5} x2={195} color="#94a3b8" dash />

      <Lbl x={190} y={30} text="50" color="#94a3b8" anchor="end" size={7} />

      <polyline points="5,30 45,33 80,38 115,44 145,48 175,58" fill="none" stroke="#ef4444" strokeWidth="2" />

      <circle cx="145" cy="48" r="4" fill="#ef4444" />

      <Lbl x={100} y={75} text="RSI crosses below 40  -  weakness" color="#ef4444" />

    </svg>

  ),



  MACD_BULLISH_CROSSOVER: (

    <svg viewBox="0 0 200 80" className="w-full">

      <HL y={45} x1={5} x2={195} color="#334155" />

      <Lbl x={190} y={43} text="0" color="#94a3b8" anchor="end" size={7} />

      <polyline points="5,62 40,58 75,54 100,50 130,38 165,28 185,22" fill="none" stroke="#6366F1" strokeWidth="2" />

      <polyline points="5,65 40,62 75,60 100,55 130,48 165,42 185,38" fill="none" stroke="#f59e0b" strokeWidth="1.5" strokeDasharray="4,2" />

      <circle cx="120" cy="52" r="4" fill="#16C784" />

      <Lbl x={5} y={25} text="MACD" color="#6366F1" anchor="start" size={7} />

      <Lbl x={5} y={35} text="Signal" color="#f59e0b" anchor="start" size={7} />

      <Lbl x={100} y={75} text="MACD crosses above signal  -  BUY" color="#16C784" />

    </svg>

  ),



  MACD_BEARISH_CROSSOVER: (

    <svg viewBox="0 0 200 80" className="w-full">

      <HL y={35} x1={5} x2={195} color="#334155" />

      <Lbl x={190} y={33} text="0" color="#94a3b8" anchor="end" size={7} />

      <polyline points="5,22 40,26 75,30 100,34 130,42 165,52 185,58" fill="none" stroke="#6366F1" strokeWidth="2" />

      <polyline points="5,18 40,21 75,24 100,28 130,34 165,42 185,46" fill="none" stroke="#f59e0b" strokeWidth="1.5" strokeDasharray="4,2" />

      <circle cx="118" cy="38" r="4" fill="#ef4444" />

      <Lbl x={5} y={15} text="MACD" color="#6366F1" anchor="start" size={7} />

      <Lbl x={5} y={25} text="Signal" color="#f59e0b" anchor="start" size={7} />

      <Lbl x={100} y={75} text="MACD crosses below signal  -  SELL" color="#ef4444" />

    </svg>

  ),



  MACD_HISTOGRAM_POSITIVE: (

    <svg viewBox="0 0 200 80" className="w-full">

      <HL y={55} x1={5} x2={195} color="#334155" />

      <Lbl x={190} y={53} text="0" color="#94a3b8" anchor="end" size={7} />

      {[{x:10,h:8},{x:30,h:14},{x:50,h:20},{x:70,h:26},{x:90,h:30},{x:110,h:28},{x:130,h:22}].map((b,i)=>(

        <rect key={i} x={b.x} y={55-b.h} width={14} height={b.h} fill="#16C784" opacity="0.8" rx="1" />

      ))}

      <Lbl x={100} y={75} text="Histogram above zero  -  bulls in control" color="#16C784" />

    </svg>

  ),



  PRICE_ABOVE_SMA20: (

    <svg viewBox="0 0 200 80" className="w-full">

      <polyline points="5,62 30,58 55,52 80,46 105,40 130,35 155,28 180,22" fill="none" stroke="#6366F1" strokeWidth="1.5" strokeDasharray="4,2" />

      <C x={10} o={55} c={46} h={43} l={58} w={13} />

      <C x={28} o={46} c={38} h={35} l={49} w={13} />

      <C x={46} o={38} c={30} h={27} l={41} w={13} />

      <C x={64} o={30} c={22} h={19} l={33} w={13} />

      <Lbl x={185} y={20} text="SMA20" color="#6366F1" anchor="end" size={7} />

      <Lbl x={100} y={75} text="Price stays above SMA20  -  uptrend" color="#16C784" />

    </svg>

  ),



  PRICE_ABOVE_SMA50: (

    <svg viewBox="0 0 200 80" className="w-full">

      <polyline points="5,68 55,62 105,55 155,48 195,42" fill="none" stroke="#f59e0b" strokeWidth="1.5" strokeDasharray="4,2" />

      <C x={10} o={55} c={45} h={42} l={58} w={13} />

      <C x={30} o={45} c={35} h={32} l={48} w={13} />

      <C x={50} o={35} c={25} h={22} l={38} w={13} />

      <C x={70} o={25} c={15} h={12} l={28} w={13} />

      <Lbl x={185} y={40} text="SMA50" color="#f59e0b" anchor="end" size={7} />

      <Lbl x={100} y={75} text="Price above SMA50  -  medium-term uptrend" color="#16C784" />

    </svg>

  ),



  PRICE_ABOVE_SMA200: (

    <svg viewBox="0 0 200 80" className="w-full">

      <HL y={55} x1={5} x2={195} color="#94a3b8" dash />

      <Lbl x={190} y={53} text="SMA200" color="#94a3b8" anchor="end" size={7} />

      <C x={10} o={42} c={32} h={28} l={45} w={13} />

      <C x={30} o={32} c={22} h={18} l={35} w={13} />

      <C x={50} o={22} c={14} h={10} l={26} w={13} />

      <C x={70} o={14} c={8}  h={5}  l={18} w={13} />

      <Lbl x={100} y={75} text="Bull market  -  price well above SMA200" color="#16C784" />

    </svg>

  ),



  PRICE_BELOW_SMA20: (

    <svg viewBox="0 0 200 80" className="w-full">

      <polyline points="5,18 30,22 55,28 80,34 105,40 130,46 155,52 180,58" fill="none" stroke="#6366F1" strokeWidth="1.5" strokeDasharray="4,2" />

      <C x={10} o={28} c={38} h={25} l={42} w={13} />

      <C x={28} o={38} c={48} h={35} l={52} w={13} />

      <C x={46} o={48} c={58} h={45} l={62} w={13} />

      <C x={64} o={58} c={68} h={55} l={72} w={13} />

      <Lbl x={185} y={60} text="SMA20" color="#6366F1" anchor="end" size={7} />

      <Lbl x={100} y={75} text="Price below SMA20  -  downtrend, avoid longs" color="#ef4444" />

    </svg>

  ),



  GOLDEN_CROSS: (

    <svg viewBox="0 0 200 80" className="w-full">

      <polyline points="5,65 55,58 90,50 120,38 160,25 195,18" fill="none" stroke="#f59e0b" strokeWidth="2" />

      <polyline points="5,58 55,55 90,52 120,50 160,46 195,42" fill="none" stroke="#94a3b8" strokeWidth="1.5" strokeDasharray="4,2" />

      <circle cx="100" cy="51" r="5" fill="#16C784" opacity="0.9" />

      <Lbl x={185} y={15} text="SMA50" color="#f59e0b" anchor="end" size={7} />

      <Lbl x={185} y={40} text="SMA200" color="#94a3b8" anchor="end" size={7} />

      <Lbl x={100} y={75} text="SMA50 crosses above SMA200  -  Bull market" color="#16C784" />

    </svg>

  ),



  DEATH_CROSS: (

    <svg viewBox="0 0 200 80" className="w-full">

      <polyline points="5,22 55,28 90,35 120,45 160,58 195,65" fill="none" stroke="#f59e0b" strokeWidth="2" />

      <polyline points="5,30 55,32 90,34 120,36 160,40 195,44" fill="none" stroke="#94a3b8" strokeWidth="1.5" strokeDasharray="4,2" />

      <circle cx="100" cy="35" r="5" fill="#ef4444" opacity="0.9" />

      <Lbl x={185} y={68} text="SMA50" color="#f59e0b" anchor="end" size={7} />

      <Lbl x={185} y={42} text="SMA200" color="#94a3b8" anchor="end" size={7} />

      <Lbl x={100} y={75} text="SMA50 crosses below SMA200  -  Bear market" color="#ef4444" />

    </svg>

  ),



  ADX_STRONG_TREND: (

    <svg viewBox="0 0 200 80" className="w-full">

      <HL y={40} x1={5} x2={195} color="#f59e0b" dash />

      <Lbl x={190} y={38} text="25" color="#f59e0b" anchor="end" size={7} />

      <polyline points="5,68 40,62 75,55 100,44 125,32 155,22 180,16" fill="none" stroke="#6366F1" strokeWidth="2" />

      <circle cx="112" cy="40" r="4" fill="#f59e0b" />

      <Lbl x={5} y={15} text="ADX" color="#6366F1" anchor="start" size={7} />

      <Lbl x={100} y={75} text="ADX above 25  -  strong trend exists" color="#f59e0b" />

    </svg>

  ),



  NEAR_52W_HIGH: (

    <svg viewBox="0 0 200 80" className="w-full">

      <HL y={12} x1={5} x2={195} color="#16C784" dash />

      <Lbl x={190} y={10} text="52W High" color="#16C784" anchor="end" size={7} />

      <HL y={68} x1={5} x2={195} color="#ef4444" dash />

      <Lbl x={190} y={75} text="52W Low" color="#ef4444" anchor="end" size={7} />

      <C x={80} o={22} c={18} h={15} l={25} w={22} />

      <text x="115" y="18" fill="#16C784" fontSize="8">~ within 5%</text>

      <Lbl x={100} y={75} text="" color="#94a3b8" />

    </svg>

  ),



  NEAR_52W_LOW: (

    <svg viewBox="0 0 200 80" className="w-full">

      <HL y={12} x1={5} x2={195} color="#16C784" dash />

      <Lbl x={190} y={10} text="52W High" color="#16C784" anchor="end" size={7} />

      <HL y={68} x1={5} x2={195} color="#ef4444" dash />

      <Lbl x={190} y={75} text="52W Low" color="#ef4444" anchor="end" size={7} />

      <C x={80} o={62} c={58} h={55} l={65} w={22} />

      <text x="115" y="72" fill="#ef4444" fontSize="8">~ within 5%</text>

    </svg>

  ),



  '52W_HIGH_TODAY': (

    <svg viewBox="0 0 200 80" className="w-full">

      <polyline points="20,60 60,40 100,35 140,25 180,18" fill="none" stroke="#16C784" strokeWidth="2" />

      <circle cx="180" cy="18" r="5" fill="#16C784" />

      <text x="145" y="25" fill="#16C784" fontSize="10">New 52W High</text>

    </svg>

  ),



  CLOSE_ABOVE_PREV_HIGH: (

    <svg viewBox="0 0 200 80" className="w-full">

      <HL y={45} color="#16C784" dash />

      <Lbl x={5} y={43} text="Previous High" color="#16C784" anchor="start" size={7} />

      <C x={100} o={55} c={35} h={32} l={58} w={28} />

      <text x="150" y="25" fill="#16C784" fontSize="12">^ Break</text>

    </svg>

  ),



  CLOSE_BELOW_PREV_LOW: (

    <svg viewBox="0 0 200 80" className="w-full">

      <HL y={45} color="#ef4444" dash />

      <Lbl x={5} y={43} text="Previous Low" color="#ef4444" anchor="start" size={7} />

      <C x={100} o={35} c={55} h={58} l={32} w={28} />

      <text x="150" y="60" fill="#ef4444" fontSize="12">v Break</text>

    </svg>

  ),



  'NR7': (

    <svg viewBox="0 0 200 80" className="w-full">

      <rect x={85} y={35} width={30} height={20} fill="none" stroke="#6366F1" strokeWidth="2" />

      <C x={80} o={45} c={42} h={40} l={50} w={18} />

      <Lbl x={100} y={75} text="Narrow Range 7  -  Coiled Spring" color="#6366F1" />

    </svg>

  ),



  INSIDE_DAY: (

    <svg viewBox="0 0 200 80" className="w-full">

      <rect x={70} y={30} width={60} height={30} fill="none" stroke="#94a3b8" strokeWidth="2" strokeDasharray="3,2" />

      <Lbl x={90} y={50} text="Mother" color="#94a3b8" fontSize={9} />

      <C x={90} o={45} c={42} h={40} l={50} w={12} />

      <Lbl x={100} y={75} text="Inside Day  -  Ready to Break" color="#6366F1" />

    </svg>

  ),



  BREAKOUT_20D_HIGH: (

    <svg viewBox="0 0 200 80" className="w-full">

      <HL y={45} color="#ef4444" dash />

      <polyline points="20,60 60,50 100,45 140,30 180,20" fill="none" stroke="#16C784" strokeWidth="2" />

      <circle cx="180" cy="20" r="4" fill="#16C784" />

      <Lbl x={100} y={75} text="Breakout Above 20D High" color="#16C784" />

    </svg>

  ),



  BREAKDOWN_20D_LOW: (

    <svg viewBox="0 0 200 80" className="w-full">

      <HL y={35} color="#16C784" dash />

      <polyline points="20,20 60,30 100,35 140,50 180,60" fill="none" stroke="#ef4444" strokeWidth="2" />

      <circle cx="180" cy="60" r="4" fill="#ef4444" />

      <Lbl x={100} y={75} text="Breakdown Below 20D Low" color="#ef4444" />

    </svg>

  ),



  CONSOLIDATION_BREAKOUT: (

    <svg viewBox="0 0 200 80" className="w-full">

      <rect x={30} y={40} width={70} height={20} fill="none" stroke="#94a3b8" strokeWidth="2" strokeDasharray="3,2" />

      <polyline points="130,60 160,40 190,20" fill="none" stroke="#16C784" strokeWidth="2" />

      <Lbl x={65} y={75} text="Consolidation" color="#94a3b8" />

      <Lbl x={155} y={75} text="Breakout" color="#16C784" />

    </svg>

  ),



  VOLUME_SPIKE: (

    <svg viewBox="0 0 200 80" className="w-full">

      <rect x={15} y={60} width={10} height={15} fill="#94a3b8" />

      <rect x={35} y={55} width={10} height={20} fill="#94a3b8" />

      <rect x={55} y={20} width={10} height={55} fill="#16C784" opacity="0.8" />

      <text x="70" y="50" fill="#16C784" fontSize="12">^ 2-3x avg</text>

      <Lbl x={100} y={75} text="Volume Spike  -  Something Happened" color="#16C784" />

    </svg>

  ),



  BREAKOUT_VOLUME_SPIKE: (

    <svg viewBox="0 0 200 80" className="w-full">

      <HL y={45} color="#ef4444" dash />

      <polyline points="20,60 50,48 80,45 110,32 140,25 170,18" fill="none" stroke="#16C784" strokeWidth="2" />

      <rect x={130} y={30} width={16} height={35} fill="#16C784" opacity="0.7" />

      <text x="105" y="20" fill="#16C784" fontSize="10">Price + Volume</text>

      <Lbl x={100} y={75} text="Highest Conviction Breakout" color="#16C784" />

    </svg>

  ),



  BULLISH_ENGULFING: (

    <svg viewBox="0 0 200 80" className="w-full">

      <C x={70} o={55} c={60} h={58} l={62} w={18} />

      <C x={110} o={62} c={35} h={32} l={65} w={28} />

      <Lbl x={92} y={75} text="Bullish Engulfing" color="#16C784" />

    </svg>

  ),

};


